// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniMyAccountStyles } from "@steiner/App/Components/MiniMyAccount/MiniMyAccount";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.linksContainer = {
    css: css`
        padding: 16px 12px;
    `,
};

miniMyAccountStyles.title = {
    variant: "h5",
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 16px;
    `,
};

miniMyAccountStyles.gridContainer = {
    gap: 8,
    css: css`
        margin-bottom: 16px;
    `,
};

miniMyAccountStyles.linkGridItem = {
    width: 6,
};

miniMyAccountStyles.link = {
    typographyProps: {
        size: 12,
    },
};

miniMyAccountStyles.sessionGridItem = {
    width: 12,
};

miniMyAccountStyles.sessionLabel = {
    size: 12,
    weight: fontConfig.weight.semiBold,
    css: css`
        white-space: nowrap;
        margin-right: 5px;
    `,
};

miniMyAccountStyles.sessionValue = {
    size: 12,
    css: css`
        ${ellipsis(1)}
    `,
};

miniMyAccountStyles.signOutContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 20px;
        padding: 16px 12px;
        background: ${color("common.ui2")};
    `,
};

miniMyAccountStyles.billToButton = {
    variant: "primary",
    css: css`
        width: 100%;
    `,
};

miniMyAccountStyles.signOutButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};

miniMyAccountStyles.documentLink = {
    typographyProps: {
        css: css`
            line-break: anywhere;
        `,
    },
};
